export const criteria = {
  COMPLETION: 'COMPLETION',
  PERIOD: 'PERIOD',
  DELIVERY: 'DELIVERY',
  INSTALLATION: 'INSTALLATION',
  MD: 'MD',
}
export const type = {
  SERVICE: 'SERVICE',
  LICENSE: 'LICENSE',
  LICENSE_MA: 'LICENSE_MA',
  SUBSCRIPTION: 'SUBSCRIPTION',
  HARDWARE_MA: 'HARDWARE_MA',
  HARDWARE: 'HARDWARE',
  OTHER_SERVICE: 'OTHER_SERVICE',
  CR: 'CR',
}
export const initRevType = {
  COMPLETION: 'COMPLETION',
  PERIOD: 'PERIOD',
  MD: 'MD',
}
export const monthRevType = {
  DELIVERY: 'DELIVERY',
  INSTALLATION: 'INSTALLATION',
  MD: 'MD',
  COMPLETION: 'COMPLETION',
}
export const revenueType = {
  SERVICE: {
    name: 'Service',
    color: '#6FCF97',
    resources_price: true,
    rev_percent: true,
    init_rev: true,
    criteria: [
      {
        label: '% Completion',
        value: criteria.COMPLETION,
      },
      {
        label: 'Period',
        value: criteria.PERIOD,
      },
      {
        label: 'Man-Days',
        value: criteria.MD,
      },
      {
        label: 'Delivery',
        value: criteria.DELIVERY,
      },
    ],
  },
  OTHER_SERVICE: {
    name: 'Other Service',
    color: '#F2994A',
    resources_price: false,
    rev_percent: true,
    init_rev: true,
    criteria: [
      {
        label: '% Completion',
        value: criteria.COMPLETION,
      },
      {
        label: 'Period',
        value: criteria.PERIOD,
      },
      {
        label: 'Man-Days',
        value: criteria.MD,
      },
      {
        label: 'Delivery',
        value: criteria.DELIVERY,
      },
    ],
  },
  HARDWARE: {
    name: 'Hardware',
    color: '#2D9CDB',
    resources_price: false,
    rev_percent: false,
    init_rev: true,
    criteria: [
      {
        label: 'Delivery',
        value: criteria.DELIVERY,
      },
      {
        label: 'Delivery & Installation',
        value: criteria.INSTALLATION,
      },
    ],
  },
  HARDWARE_MA: {
    name: 'Hardware MA',
    color: '#2D9CDB',
    resources_price: false,
    rev_percent: false,
    init_rev: true,
    criteria: [
      {
        label: 'Period',
        value: criteria.PERIOD,
      },
      {
        label: 'Delivery',
        value: criteria.DELIVERY,
      },
    ],
  },
  LICENSE: {
    name: 'License',
    color: '#9B51E0',
    resources_price: false,
    rev_percent: false,
    init_rev: true,
    criteria: [
      {
        label: 'Delivery',
        value: criteria.DELIVERY,
      },
      {
        label: 'Delivery & Installation',
        value: criteria.INSTALLATION,
      },
    ],
  },
  LICENSE_MA: {
    name: 'License MA',
    color: '#9B51E0',
    resources_price: false,
    rev_percent: false,
    init_rev: true,
    criteria: [
      {
        label: 'Period',
        value: criteria.PERIOD,
      },
      {
        label: 'Delivery',
        value: criteria.DELIVERY,
      },
    ],
  },
  SUBSCRIPTION: {
    name: 'Subscription',
    color: '#9B51E0',
    // resources_price: false,
    // rev_percent: false,
    // init_rev: true,
    criteria: [
      {
        label: 'Period',
        value: criteria.PERIOD,
      },
      {
        label: 'Delivery',
        value: criteria.DELIVERY,
      },
    ],
  },
  CR: {
    name: 'CR',
    color: '#F36767',
    resources_price: false,
    rev_percent: false,
    init_rev: true,
    criteria: [
      {
        label: '% Completion',
        value: criteria.COMPLETION,
      },
      {
        label: 'Period',
        value: criteria.PERIOD,
      },
      {
        label: 'Delivery',
        value: criteria.DELIVERY,
      },
      {
        label: 'Delivery & Installation',
        value: criteria.INSTALLATION,
      },
      {
        label: 'Man-Days',
        value: criteria.MD,
      },
    ],
  },
}



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-revenue-planning/constants.js